//PartyDetailSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as PartyDetailAPI from "./PartyDetailAPI";

export const fetchPartySignUpDetails = createAsyncThunk(
  "PartyDetail/fetchPartySignUpDetails",
  async (email, { rejectWithValue }) => {
    try {
      const response = await PartyDetailAPI.fetchPartySignUpDetails(email);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || "Something went wrong");
    }
  }
);

export const fetchRelationData = createAsyncThunk(
  "PartyDetail/fetchRelationData",
  PartyDetailAPI.fetchRelationData
);

export const fetchOccupationData = createAsyncThunk(
  "PartyDetail/fetchOccupationData",
  PartyDetailAPI.fetchOccupationData
);

export const fetchIDTypeData = createAsyncThunk(
  "PartyDetail/fetchIDTypeData",
  PartyDetailAPI.fetchIDTypeData
);

export const fetchGender = createAsyncThunk(
  "PartyDetail/fetchGender",
  PartyDetailAPI.fetchGender
);

export const InsertPartyDetails = createAsyncThunk(
  "PartyDetail/InsertPartyDetails",
  async (partyDetails, { rejectWithValue }) => {
    try {
      //debugger;
      const response = await PartyDetailAPI.InsertPartyDetails(partyDetails);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || "Something went wrong");
    }
  }
);

export const InsertPartyDetailsPaperLess = createAsyncThunk(
  "PartyDetail/InsertPartyDetailsPaperLess",
  async (partyDetails, { rejectWithValue }) => {
    try {
      //debugger;
      const response = await PartyDetailAPI.InsertPartyDetailsPaperLess(
        partyDetails
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || "Something went wrong");
    }
  }
);

export const ModifyPartyDetails = createAsyncThunk(
  "PartyDetail/ModifyPartyDetails",
  async (partyDetails, { rejectWithValue }) => {
    try {
      //debugger;
      const response = await PartyDetailAPI.ModifyPartyDetails(partyDetails);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || "Something went wrong");
    }
  }
);

export const ModifyPartyDetailsPaperless = createAsyncThunk(
  "PartyDetail/ModifyPartyDetailsPaperless",
  async (partyDetails, { rejectWithValue }) => {
    try {
      //debugger;
      const response = await PartyDetailAPI.ModifyPartyDetailsPaperless(
        partyDetails
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || "Something went wrong");
    }
  }
);

// Create slice
const partyDetailSlice = createSlice({
  name: "PartyDetail",
  initialState: {
    relationData: [],
    occupationData: [],
    idTypeData: [],
    genderData: [],
    partySignUpDetails: null,
    adhaarEkyc: "",
    confirmed: null,
    status: "idle",
    error: null,
    savefirstparty: [],
    savesecondparty: [],
    savewitness: [],
    // isModifying: false,
  },
  reducers: {
    setFirstPartyDetails: (state, action) => {
      state.savefirstparty = action.payload;
    },
    setSecondPartyDetails: (state, action) => {
      state.savesecondparty = action.payload;
    },
    setWitnessDetails: (state, action) => {
      state.savewitness = action.payload;
    },

    updatePartyDetails: (state, action) => {
      const { savefirstparty, savesecondparty, savewitness } = action.payload;
      state.savefirstparty = savefirstparty;
      state.savesecondparty = savesecondparty;
      state.savewitness = savewitness;
    },

    resetPartyDetails: (state, action) => {
      state.savefirstparty = state.initialState;
      state.savesecondparty = state.initialState;
      state.savewitness = state.initialState;
    },
    resetPartySignUpDetails: (state) => {
      state.partySignUpDetails = null;
    },
    setConfirmedYes: (state) => {
      state.confirmed = "yes";
    },
    setConfirmedNo: (state) => {
      state.confirmed = "no";
    },
    resetConfirmed: (state) => {
      state.confirmed = null; // Reset confirmed to null
    },
    resetAdhaarEkyc: (state) => {
      state.adhaarEkyc = state.initialState;
    },
    // setModifying: (state, action) => {
    //   state.isModifying = action.payload; // Update modifying state
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelationData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRelationData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.relationData = action.payload;
      })
      .addCase(fetchRelationData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchOccupationData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOccupationData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.occupationData = action.payload;
      })
      .addCase(fetchOccupationData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchIDTypeData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchIDTypeData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.idTypeData = action.payload;
      })
      .addCase(fetchIDTypeData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchGender.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchGender.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.genderData = action.payload;
      })
      .addCase(fetchGender.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchPartySignUpDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPartySignUpDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.partySignUpDetails = action.payload;
        // state.adhaarEkyc = action.payload[0].aadhaar_ekyc;
        state.adhaarEkyc = action.payload?.[0]?.aadhaar_ekyc || "";
      })
      .addCase(fetchPartySignUpDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const {
  setFirstPartyDetails,
  setSecondPartyDetails,
  setWitnessDetails,
  resetPartyDetails,
  resetPartySignUpDetails,
  updatePartyDetails,
  setConfirmedYes,
  setConfirmedNo,
  resetConfirmed,
  resetAdhaarEkyc,
  // setModifying,
} = partyDetailSlice.actions;

export const selectFirstParty = (state) => state.PartyDetail.savefirstparty;
export const selectSecondParty = (state) => state.PartyDetail.savesecondparty;
export const selectWitness = (state) => state.PartyDetail.savewitness;
export const selectPartySignUpDetails = (state) =>
  state.PartyDetail.partySignUpDetails;
export const selectConfirmed = (state) => state.PartyDetail.confirmed;
export const selectAdhaarEkyc = (state) => state.PartyDetail.adhaarEkyc;

// export const selectIsModifying = (state) => state.PartyDetail.isModifying;

export default partyDetailSlice.reducer;
